import { memo } from 'react';

import Typography from '../../Typography/index.ts';
import { Progress } from './styled.ts';

export const FileProgress = memo(function FileProgress({ progress }: { progress: number }) {
  return (
    <>
      <Progress $progress={progress} />
      <Typography.TextMedium>
        {progress}
        {'%'}
      </Typography.TextMedium>
    </>
  );
});
